import { render, staticRenderFns } from "./repayment-data-summarization.vue?vue&type=template&id=535b82c9&scoped=true&"
import script from "./repayment-data-summarization.vue?vue&type=script&lang=js&"
export * from "./repayment-data-summarization.vue?vue&type=script&lang=js&"
import style0 from "./repayment-data-summarization.vue?vue&type=style&index=0&id=535b82c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b82c9",
  null
  
)

export default component.exports